import { useState } from 'react'
import { useLocation, Link } from 'react-router-dom'
import CalculatorForm from '../components/CalculatorForm.jsx'
import BlendCalc from '../components/BlendCalc.jsx'
import CalculatorBanner from '../components/CalculatorBanner.jsx'
import RatingWidget from '../components/RatingWidget.jsx'
import CalcGuide from '../components/CalcGuide.jsx'
import FaqBlock from '../components/FaqBlock.jsx'
import Seo from '../components/Seo.jsx'
import { CALC_FAQ } from '../data/calcFaq.js'
import { faqLd } from '../lib/faq.js'

export default function Calculator() {
  const location = useLocation()
  // Allow loading a saved calc via navigation state (from the Saved page).
  const initial = location.state?.calc || undefined
  const [mode, setMode] = useState('single') // 'single' | 'blend'

  return (
    <main className="page">
      {/* Home (/) is the canonical target for "peptide calculator" — it embeds the
          same calculator. Point this page's canonical at / to consolidate ranking
          signals (no 301: the page stays live for saved-calc / preset deep-links). */}
      <Seo
        title="Peptide Calculator — Single & Blend | CalculateMyPeptides"
        description="Calculate single-peptide or multi-peptide blend doses: enter vial mg, bacteriostatic water, and target dose to get the exact insulin-syringe units, concentration, and doses per vial."
        canonical="/"
        jsonLd={faqLd('Peptide reconstitution calculator — FAQ', CALC_FAQ)}
        breadcrumbs={[{ name: 'Home', path: '/' }, { name: 'Calculator', path: '/calculator' }]}
      />
      <div className="container">
        <CalculatorBanner />
        <div style={{ marginBottom: 22 }}>
          <h1 className="section-title">Peptide Calculator</h1>
          <p className="section-sub">
            Enter your vial and dose to get the exact amount to draw — down to the insulin unit.
          </p>
          <Link to="/guide" className="guide-callout">
            🧑‍⚕️ <span>New to mixing, or prescribed a dose? <strong>Try the step-by-step guide →</strong></span>
          </Link>
        </div>

        <div className="seg calc-mode" role="tablist" aria-label="Calculator type">
          <button type="button" role="tab" aria-selected={mode === 'single'} className={mode === 'single' ? 'active' : ''} onClick={() => setMode('single')}>Single peptide</button>
          <button type="button" role="tab" aria-selected={mode === 'blend'} className={mode === 'blend' ? 'active' : ''} onClick={() => setMode('blend')}>Blend (one vial, multiple peptides)</button>
        </div>

        {mode === 'single' ? (
          <CalculatorForm initial={initial} />
        ) : (
          <>
            <BlendCalc />
            <p className="muted small" style={{ marginTop: 10 }}>
              For more on blends — the math, examples, and FAQ — see the <Link to="/blend">full blend calculator</Link>.
            </p>
          </>
        )}

        <RatingWidget />

        <div className="calc-guide-wrap card card-pad" style={{ marginTop: 26 }}>
          <CalcGuide />
        </div>

        <FaqBlock title="Reconstitution & dosing FAQ" items={CALC_FAQ} />
      </div>
    </main>
  )
}
